export default "__VITE_ASSET__CsMg6pEL__"